<template>
  <SelectComponent :is-wizard="true" />
</template>

<script>
import SelectComponent from "../SelectComponent";
export default {
  name: "Wizard3",
  components: { SelectComponent }
};
</script>

<style scoped></style>
